<!-- Table -->
<div class="content-wrapper">
  <div class="row">
    <div class="col-lg-12 grid-margin stretch-card">
      <div class="card">
        <div class="card-body">
          <h4 class="card-title"> Pending Approvals</h4>
          <div class="table-responsive pt-3">
            <table class="table table--striped table-hover">
              <thead>
                <tr>
                  <th>
                    Reference
                  </th>
                  <th>
                    Request Date
                  </th>
                  <th>
                    Requester
                   </th>
                  <th>
                   Requester Designation
                  </th>
                  <th>
                    Employee Name
                  </th>
                  <th>
                    Employee Function
                  </th>
                  <th>
                    Employee Location
                  </th>
                 
                </tr>
              </thead>
              <tbody>
                 <tr *ngFor="let datas of JobRotations" (click)="open(datas)" class="clickable">
                  <td>{{datas.reference}}</td>

                  <td>{{datas.createdDate | date: 'dd MMMM yyyy'}}</td>

                  <td>{{datas.requesterName}}</td>

                  <td>{{datas.requesterDesignation}}</td>

                  <td>{{datas.employeeName}}</td>

                  <td>{{datas.employeeFunction}}</td>

                  <td>{{datas.employeeLocation}}</td>

                </tr>
              </tbody>
            </table>
          </div>

           <div *ngIf="!JobRotations.length" style="text-align: center; padding: 18px;">
            <h4 style="color: rgba(128, 128, 128, 0.741); ">You have no request pending approval</h4>
          </div>
        </div>
      </div>
    </div>


  </div>
</div>



<!-- Drawer -->
<nz-drawer [nzBodyStyle]="{ overflow: 'auto' }" [nzMaskClosable]="false" [nzWidth]="1040"
  [nzVisible]="ViewJobRotation" [nzFooter]="footerTpl" (nzOnClose)="close()">

  <!-- Side swipe content -->
  <div class="row d-print-block">
    <div class="col-lg-12 grid-margin stretch-card">
      <div class="card">
        <h5 class="card-title">Job Rotation Details</h5>
        <div class="card-body">
      
        <div class="row">
          <div  class="col">
            <h5 class="card-title"> Job Rotation Details</h5>
          </div>
          <div  class="col">
            <img src="../../../assets/images/holcim_logo_color.svg" alt=""
            srcset="" style="height: 30px;">
          </div>
        </div>
      
        <div class="card-body">
          <div class="row">
            <div class="col">
              <label><b>Request Reference</b></label>
              <p>{{ ApproveRequest?.reference }}</p>
            </div>

            <div class="col">
              <label><b>Requester Name</b></label>
              <p>{{ ApproveRequest?.requesterName }}</p>
            </div>
          </div>

          <div class="row">
            <div class="col">
              <label><b>Requester Designation</b></label>
              <p>{{ ApproveRequest?.requesterDesignation }}</p>
            </div>

            <div class="col">
              <label><b>Request Date</b></label>
              <p>{{ ApproveRequest?.createdDate | date: 'dd MMMM yyyy' }}</p>
            </div>
          </div>

          <hr>

          <div class="row">
            <div class="col">
              <label><b>Employee Name</b></label>
              <p>{{ ApproveRequest?.employeeName }}</p>
            </div>

            <div class="col">
              <label><b>Employee Function</b></label>
              <p>{{ ApproveRequest?.employeeFunction }}</p>
            </div>
          </div>

          <div class="row">
            <div class="col">
              <label><b>Current Location</b></label>
              <p>{{ ApproveRequest?.employeeLocation}}</p>
            </div>

            <div class="col">
              <label><b>Current Unit</b></label>
              <p>{{ ApproveRequest?.employeeUnit }}</p>
            </div>
          </div>

          <div class="row">
            <div class="col">
              <label><b> Current Designation</b></label>
              <p>{{ ApproveRequest?.employeeCurrentDesignation }}</p>
            </div>

             
          </div>

          <div class="row">
            <div class="col">
              <label><b>Current Manager</b></label>
              <p>{{ ApproveRequest?.currentManager}}</p>
            </div>

            <div class="col">
              <label><b>Current Head of Unit</b></label>
              <p>{{ ApproveRequest?.currentUnitHead }}</p>
            </div>
          </div>

          <div class="row">
            <div class="col">
              <div class="form-group">
                <label><b>Rotation Start Date</b></label>
                <p>{{ ApproveRequest?.rotationStartDate | date: 'dd MMMM yyyy'}}</p>
              </div>
            </div>

            <div class="col">
              <div class="form-group">
                <label><b>Rotation End Date</b></label>
                <p>{{ ApproveRequest?.rotationEndDate | date: 'dd MMMM yyyy'}}</p>
              </div>
            </div>
          </div>

          <div class="row" *ngIf = "ApproveRequest?.currentSection">
            <div class="col">
              <label><b>Current Section</b></label>
              <p>{{ ApproveRequest?.currentSection}}</p>
            </div>
          </div>

          <hr>

          <div class="row">
            <div class="col">
              <label><b>Receiving Function</b></label>
              <p>{{ ApproveRequest?.receivingFunction}}</p>
            </div>

            <div class="col">
              <label><b>Receiving Unit</b></label>
              <p>{{ ApproveRequest?.receivingUnit }}</p>
            </div>
          </div>

          <div class="row">
            <div class="col">
              <label><b>Receiving Location</b></label>
              <p>{{ ApproveRequest?.receivingLocation}}</p>
            </div>

           
          </div>

          <div class="row" *ngIf = "ApproveRequest?.newSection">
            <div class="col">
              <label><b>New Section</b></label>
              <p>{{ ApproveRequest?.newSection}}</p>
            </div>
          </div>
          
        </div>

        <div class="col">
            <label><b>Comment</b></label>
            <input name="" id="" [(ngModel)]="Comment" class="form-control" placeholder="">
        </div>
       
      </div>

    </div>
    </div>
   <!-- Approvals -->
    <div class="card-body" >
    <h5 class="card-title">Approvals</h5>
    <div class="table-responsive" >
      <table class="table table--striped table-hover">
        <thead>
          <tr>
            <th>
              Designation Name
            </th>
            <th>
              Approved By
            </th>
            <th>
              Status
            </th>
            <th>
              Date Approved
            </th>
            <th>
              Comment
            </th> 
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let approval of ManPowerApprovals">
            <td>{{approval.name}}</td>
            <td>{{approval.designation }}</td>
            <td>{{approval.status}}</td>
            <td>{{approval.approvalDate | date: 'dd MMMM yyyy hh:mm a'}}</td>
            <td>{{approval.message}}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div *ngIf="!ManPowerApprovals?.length"
      style="color: rgba(128, 128, 128, 0.741); text-align: center; padding: 18px;">
      <h4 style="color: rgba(128, 128, 128, 0.741);">No approval has been granted.</h4>
    </div>
    <!-- Approvals -->
    </div>
  <ng-template #footerTpl>
    <div style="float: right" class="d-print-none">
    
      <a  (click)="approveManPower()"> 
        <span style="margin-right: 8px;" class="btn btn-primary">
            Approve 
        </span>
    </a> 
    
    <a   (click)="rejectManPower()"> 
      <span style="margin-right: 8px;"class="btn btn-danger">
          Reject
      </span>
  </a> 
      
      <button class="btn btn-light" style="margin-right: 8px;" (click)="close()">Close</button>
    </div>
  </ng-template>
  </div>

</nz-drawer>
<!-- Drawer -->



<!-- ManPower HEAD COUNT Approval  Modal  -->
<nz-modal [(nzVisible)]="isManPowerpprovalModalVisible" nzTitle="Man Power Approval" (nzOnCancel)="handleCancel()">

  <div *nzModalContent>
    <div class="col">
      <div class="form-group">
        <label for="exampleInputCity1">APPROVED BUDGET MANPOWER FIGURE FOR THE DEPARTMENT:</label>
        <input type="number" class="form-control" id="approveManPowerFigure" placeholder="ex: 120,000" [(ngModel)]="aprovedDepartmentManpowerFigure"
          name="approveManPowerFigure" required>
      </div>
  
      <div class="form-group">
        <label for="exampleInputCity1">PRESENT MANPOWER FIGURE FOR THE DEPARTMENT:</label>
        <input type="number" class="form-control" id="presentManPowerFigure" placeholder="ex: 120,000" [(ngModel)]="presentDepartmentManpowerFigure"
          name="presentManPowerFigure" required>
      </div>
<div class="row">
  <div class="col">
    <div class="form-group">
      <label for="LevelOfCompliance">Level of Risk Exposure(Compliance)</label>
      <ng-select [(ngModel)]="LevelOfExposureCompliance" id="levelOfCompliance" name="levelOfCompliance">
        <ng-option *ngFor="let level of LevelOfCompliance" [value]="level.compliance">{{level.compliance}}
          </ng-option>
      </ng-select>
    </div>
  </div>
</div>
    

      <div class="form-group">
        <label><b>Comment</b></label>
        <input name="Comment" id="" [(ngModel)]="Comment" class="form-control" placeholder="">
      </div>
    </div>
  </div>

  <div *nzModalFooter>
    <button class="btn btn-light" (click)="handleCancel()">Cancel</button>
    <button class="btn btn-primary" (click)="sendManPowerApproval()">Approve</button>
  </div>
 
</nz-modal>

